export const french = {
    "language": "Langue",
    "languages": "Langues",
}
